.header {
  padding: 16px;
  background-color: #2c2c2c;
  display: flex;
  justify-content: center;
}

.header form {
  display: flex;
  gap: 8px;
}

.input {
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  font-size: 16px;
  width: 300px;
}